import api from '../../../@e74/services/ApiConfig';
import {fetchError, fetchStart, fetchSuccess, hideMessage} from '../Common';
export const ACTION_TYPES = {
  CREATE: 'CREATE_ROOM',
  UPDATE: 'UPDATE_ROOM',
  DELETE: 'DELETE_ROOM',
  FETCH_ALL: 'FETCH_ALL_ROOMS',
};

export const fetchAll = () => (dispatch) => {
  dispatch(fetchStart());
  api
    .room()
    .fetchAll()
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      dispatch(hideMessage());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const create = (data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .room()
    .create(data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.CREATE,
        payload: res.data,
      });
      //dispatch(showMessage('Room added successfully'));
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const update = (id, data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .room()
    .update(id, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.UPDATE,
        payload: {id, ...data},
      });
      //dispatch(showMessage('Room updated successfully'));
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .room()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      //dispatch(showMessage('Room deleted successfully'));
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
